import { render, staticRenderFns } from "./ViewOrderContainer.vue?vue&type=template&id=3879fd87&scoped=true&"
import script from "./ViewOrderContainer.vue?vue&type=script&lang=js&"
export * from "./ViewOrderContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3879fd87",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dmitrichiriuhin/code/pesoto-node/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3879fd87')) {
      api.createRecord('3879fd87', component.options)
    } else {
      api.reload('3879fd87', component.options)
    }
    module.hot.accept("./ViewOrderContainer.vue?vue&type=template&id=3879fd87&scoped=true&", function () {
      api.rerender('3879fd87', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Orders/ViewOrderContainer.vue"
export default component.exports